import { render, staticRenderFns } from "./AppNavbarUserMenu.vue?vue&type=template&id=072fcb7e&scoped=true&"
import script from "./AppNavbarUserMenu.vue?vue&type=script&lang=js&"
export * from "./AppNavbarUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarUserMenu.vue?vue&type=style&index=0&id=072fcb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fcb7e",
  null
  
)

export default component.exports